<div class="file-upload-container">
  <div class="drop-zone-wrapper">
    <div
      class="drop-zone"
      appDragDrop
      #dragDropRef="dragDrop"
      (filesDropped)="setFilesFromDrop($event)"
      [defaultText]="defaultText() | translate: locale.language"
      [successText]="successText() | translate: locale.language"
      [errorText]="errorText() | translate: locale.language">
      <div class="drop-zone-text">
        <ng-content select="[dropZoneContent]"></ng-content>
        @if (dragDropRef) {
          <span>{{ dragDropRef.dropZoneText() }}</span>
        }
      </div>

      <div class="separator">
        <ng-content select="[separatorContent]">
          <span>or</span>
        </ng-content>
      </div>

      <input
        type="file"
        #fileInput
        [accept]="acceptedTypes()"
        multiple
        (change)="setFilesFromInput($event.target)"
        style="display: none" />
      <button mat-stroked-button color="primary" (click)="clickFileInput()" type="button">
        <mat-icon>file_upload</mat-icon>
        {{ 'Sftp.Upload.Upload.Browse' | translate: locale.language }}
        <ng-content select="[browseButtonContent]"></ng-content>
      </button>
    </div>
  </div>

  <div class="file-info-wrapper">
    <ng-content select="[beforeFileList]"></ng-content>

    @if (totalFileCount() > 0) {
      <div class="file-list-header">
        <div class="file-count">
          <mat-icon>description</mat-icon>
          <span class="count-text">{{ selectedFileCount() }} / {{ totalFileCount() }}</span>
          <ng-content select="[fileCountSuffix]"></ng-content>
        </div>
        @if (totalFileCount() > 1) {
          <button mat-button color="warn" (click)="clearFiles()" type="button" class="clear-all-btn">
            <mat-icon>clear_all</mat-icon>
            Clear All
          </button>
        }
      </div>

      <div class="file-list">
        @for (fs of allFiles(); let i = $index; track $index) {
          <div class="file-card" [class.selected]="fs.selected" [class.has-warning]="fs.validationMessage || fs.validationDetails" [class.has-error]="fs.validationMessage || fs.validationDetails">
            <div class="file-checkbox">
              <mat-checkbox [checked]="fs.selected" [disabled]="!!(fs.validationMessage || fs.validationDetails)" (change)="toggleFileSelection(i)"></mat-checkbox>
            </div>
            <div class="file-info">
              <div class="file-icon">
                <mat-icon>insert_drive_file</mat-icon>
              </div>
              <div class="file-details">
                <div class="file-name" [title]="fs.file.name">{{ fs.file.name }}</div>
                <div class="file-meta">
                  <span class="file-size">{{ formatFileSize(fs.file.size) }}</span>
                  <span class="file-type">{{ fs.file.type || 'Unknown type' }}</span>
                </div>
                @if (fs.validationDetails) {
                  <mat-expansion-panel class="file-validation-panel" [class.error-panel]="fs.validationDetails.severity === 'error'" [class.warning-panel]="fs.validationDetails.severity === 'warning'">
                    <mat-expansion-panel-header>
                      <mat-panel-title class="validation-summary">
                        <mat-icon>{{ fs.validationDetails.severity === 'error' ? 'error' : 'warning' }}</mat-icon>
                        <span>{{ fs.validationDetails.summary }}</span>
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    @if (fs.validationDetails.details && fs.validationDetails.details.length > 0) {
                      <div class="validation-details-content">
                        @for (detail of fs.validationDetails.details; track $index) {
                          <div class="detail-line">{{ detail }}</div>
                        }
                      </div>
                    }
                  </mat-expansion-panel>
                }
              </div>
            </div>
            <div class="file-actions">
              @if (canPreviewFile(fs.file)) {
                <button
                  mat-icon-button
                  (click)="openSpreadsheetPreview(fs.file)"
                  type="button"
                  class="preview-btn"
                  [attr.aria-label]="'Sftp.Upload.Upload.PreviewFile' | translate: locale.language"
                  [matTooltip]="'Sftp.Upload.Upload.PreviewFile' | translate: locale.language">
                  <mat-icon>visibility</mat-icon>
                </button>
              }
              <button mat-icon-button (click)="removeFile(i)" type="button" class="remove-btn" aria-label="Remove file">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="no-files-message">
        <mat-icon>cloud_upload</mat-icon>
        <p>No files selected</p>
      </div>
    }

    @if (selectedFileCount() > maxFiles()) {
      <div class="validation-error">
        <mat-icon class="error-icon">error</mat-icon>
        <span class="error-text">
          <ng-content select="[maxFilesError]"></ng-content>
        </span>
      </div>
    }

    <ng-content select="[afterFileList]"></ng-content>
  </div>
</div>
